module.exports = __webpack_public_path__ + "img/student_default_img_girl.b5610524.png";